import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { JOURNAL_ENTRY } from "./apiRoutes";

interface UseGetJournalEntryProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getJournalEntryById = async (id: string) =>
  await axiosAuth.get(`${JOURNAL_ENTRY}/posted/${id}`);

const useGetJournalEntryById = ({
  queryParams,
  id,
}: UseGetJournalEntryProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["journal-entry", id],
    queryFn: () => getJournalEntryById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!id && (queryParams?.enabled ?? true),
  });
};

export default useGetJournalEntryById;
